import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { SensorListScene } from 'scenes';

class SensorListContainer extends AbstractContainer {

  getTasks() {

    return [
      {
        key: 'sensors',
        exec: (done, failure) => {
          API.get('sensors')
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {

    return <SensorListScene sensors={results.sensors} />
  }
}

export default SensorListContainer;
